module.exports = __webpack_public_path__ + "media/36.b378210b.mp3";